module.exports = __webpack_public_path__ + "assets/img/ma.d00267da.jpg";